import { createContext, useContext, type ReactNode } from 'react';

export type ChatSendFn = (message: string, skill?: string) => void;

const ChatSendContext = createContext<ChatSendFn | null>(null);

export interface ChatSendProviderProps {
  readonly send: ChatSendFn;
  readonly children: ReactNode;
}

/** Threads ChatPanel's `handleSubmit` down to action-card renderers
 *  (QuickReply, EmailDraft) without forcing MessageList / MessageBubble
 *  to drill a callback prop through every level. The Provider is mounted
 *  inside ChatPanel; consumers call `useChatSend()` and get `null` when
 *  rendered outside the chat surface. */
export function ChatSendProvider({ send, children }: ChatSendProviderProps) {
  return (
    <ChatSendContext.Provider value={send}>{children}</ChatSendContext.Provider>
  );
}

export function useChatSend(): ChatSendFn | null {
  return useContext(ChatSendContext);
}
